import { useDispatch } from 'react-redux';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { leaveApi } from '../../services/LeaveService';
// import profileReducer from './profileSlice';
import { Link } from "react-router-dom";
import MetaTags from 'react-meta-tags';
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
  FormGroup,
  Label,
  InputGroup,
  Badge,
} from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import Flatpickr from "react-flatpickr";
import Breadcrumbs from '../../components/Breadcrumb';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import Dropzone from "react-dropzone";
//Calendar
import FullCalendar from "@fullcalendar/react"
import dayGridPlugin from "@fullcalendar/daygrid"
import interactionPlugin, { Draggable } from "@fullcalendar/interaction"
import BootstrapTheme from "@fullcalendar/bootstrap"

import "@fullcalendar/bootstrap/main.css"
import PageLoader from '../../components/Loaders/pageLoader';
import BtnLoader from "../../components/Loaders/btnLoader";
import SweetAlert from 'react-bootstrap-sweetalert';

export default function LeaveApply({ profileData: initialProfileData, loading }) {
  const [profileData, setProfileData] = useState(
    () => JSON.parse(localStorage.getItem("authUser"))?.result || initialProfileData
  );
  const { data = [], isLoading, error, refetch } = leaveApi.useFetchAllLeavesQuery('dep||'+profileData.department._id);
  const [leaves, setTableData] = useState([]);
  const [supervisors, setSupervisorsData] = useState([]);
  const [holidays, setHolidaysData] = useState([]);
  const [combined, setCombinedData] = useState([]);
  const [users, setUsersData] = useState([]);
  const [addLeave] = leaveApi.useAddLeaveMutation();

  const [showPolicyAlert, setShowPolicyAlert] = useState(false);
  const [showErrorAlert, setShowErrorAlert] = useState(false);
  const [leaveType, setLeaveType] = useState(null);
  const [selectedFile, setFile] = useState([]);
  const [isEdit, setIsEdit] = useState(false);

  const [totalLeavesTaken, setTotTknInfo] = useState("");
  const [medicalLeaveTaken, setMedTknInfo] = useState("");
  const [leftLeave, setLeftoverInfo] = useState("");
  const [vacLeavesInfo, setVacLeaveInfo] = useState("");
  const [addLeavesInfo, setAddLeaveInfo] = useState("");
  const [medLeavesInfo, setMedLeaveInfo] = useState("");

  useEffect(() => {
    refetch(); // Trigger refetch when the component mounts
  }, [refetch]);
  useEffect(() => {
    if (data.leaves) {
      setTableData(JSON.parse(JSON.stringify(data.leaves))); // Reset with the latest fetched data
      setSupervisorsData(JSON.parse(JSON.stringify(data.supervisors)));
      setHolidaysData(JSON.parse(JSON.stringify(data.holidays)));
      setCombinedData(JSON.parse(JSON.stringify(data.combined)));
      setUsersData(JSON.parse(JSON.stringify(data.users)));
    }
    if(data.users){
      const totalLeavesTaken = data.leaves.filter((leave) => leave.appliedBy._id === profileData._id &&
              ["ann_lv", "unp_lv", "comp_lv"].includes(leave.leaveType) &&
              new Date(leave.start).getFullYear() === new Date().getFullYear()
          ).reduce((sum, leave) => sum + leave.hoursCount, 0) / 8

      setTotTknInfo(parseFloat(totalLeavesTaken.toFixed(2)));

      const medicalLeaveTaken =
      (profileData.leave.medLeaveHours -
        data.leaves.filter((leave) => leave.appliedBy._id === profileData._id && leave.leaveType === "med_lv" && new Date(leave.start).getFullYear() === new Date().getFullYear())
        .reduce((sum, leave) => sum + leave.hoursCount, 0)) / 8;
      setMedTknInfo(medicalLeaveTaken)
    }
    // Add event listeners when the component mounts
    window.addEventListener('load', getScreenHeight);
    window.addEventListener('click', getScreenHeight, { once: true });
    window.addEventListener('resize', getScreenHeight);

    // Cleanup function to remove event listeners when the component unmounts
    return () => {
      window.removeEventListener('load', getScreenHeight);
      window.removeEventListener('click', getScreenHeight);
      window.removeEventListener('resize', getScreenHeight);
    };
  }, [data]);
  useEffect(() => {
    if (profileData?.leave) {
      const calculateLeaves = (vacLeave, createdAt) => {
        const joinedDate = new Date(createdAt);
        const currentYear = new Date().getFullYear();
        // Step 1: Months from the beginning of 2024 to createdAt
        const monthsFromStartToJoin = (joinedDate.getMonth() + 1); // Months are 0-indexed, so add 1
        const vacLeaveStart = vacLeave + Math.min(currentYear - joinedDate.getFullYear(), 5)
        // Step 2: Months from createdAt to the end of 2024
        const monthsFromJoinToEnd = 12 - joinedDate.getMonth() - 1;
        const vacLeaveEnd = vacLeaveStart + 1
        // Total leaves calculation
        const totalLeaves = ((monthsFromStartToJoin / 12) * vacLeaveStart) + ((monthsFromJoinToEnd / 12) * vacLeaveEnd)
        return parseFloat(totalLeaves.toFixed(2));
      }
      const calculateLeaveInfo = (leaveHours) => {
        const days =
          removeRounding(leaveHours / 8) !== 0
            ? `${removeRounding(leaveHours / 8)} Days`
            : "";
        const hours =
          leaveHours % 8 !== 0 ? `${leaveHours % 8} Hours` : "";
        return `${days} ${hours}`.trim();
      };
      // const vacLeaveTotal = calculateLeaves(profileData.leave.vacLeave, profileData.createdAt);
      // const addLeaveTotal = parseFloat(profileData.leave.addDays[new Date().getFullYear()].reduce((sum, day) => sum + day.addDay, 0));
      // const medLeaveTotal = calculateLeaveInfo(profileData.leave.medLeaveHours);
      // setVacLeaveInfo(vacLeaveTotal);
      // setAddLeaveInfo(addLeaveTotal);
      // setMedLeaveInfo(medLeaveTotal);
      // setLeftoverInfo((vacLeaveTotal + addLeaveTotal) - totalLeavesTaken);
      setVacLeaveInfo(calculateLeaves(profileData.leave.vacLeave, profileData.createdAt));
      setAddLeaveInfo(parseFloat(profileData.leave.addDays[new Date().getFullYear()].reduce((sum, day) => sum + day.addDay, 0)));
      setMedLeaveInfo(calculateLeaveInfo(profileData.leave.medLeaveHours));
    }
  }, [profileData]);
  useEffect(() => {
    if (totalLeavesTaken) {
      setLeftoverInfo((parseFloat(addLeavesInfo) + parseFloat(vacLeavesInfo)) - totalLeavesTaken);
    }
  }, [vacLeavesInfo, totalLeavesTaken, addLeavesInfo, profileData]);
  // useEffect(() => {
  //   if (data.leaves) {
  //     setTableData(JSON.parse(JSON.stringify(data.leaves))); // Reset with the latest fetched data
  //     setSupervisorsData(JSON.parse(JSON.stringify(data.supervisors)));
  //     setHolidaysData(JSON.parse(JSON.stringify(data.holidays)));
  //     setCombinedData(JSON.parse(JSON.stringify(data.combined)));
  //     if (profileData?.leave) {
  //       const calculateLeaveInfo = (leaveHours) => {
  //         const days =
  //           removeRounding(leaveHours / 8) !== 0
  //             ? `${removeRounding(leaveHours / 8)} Days`
  //             : "";
  //         const hours =
  //           leaveHours % 8 !== 0 ? `${leaveHours % 8} Hours` : "";
  //         return `${days} ${hours}`.trim();
  //       };
  //       setVacLeaveInfo(calculateLeaveInfo(profileData.leave.vacLeaveHours));
  //       setMedLeaveInfo(calculateLeaveInfo(profileData.leave.medLeaveHours)); // Adjust field name as necessary
  //     }
  //   }
  // }, [data]);
  // Use a ref for the calendar component
  const calendarComponentRef = useRef(null);
  const formRef = useRef(null);
  // Handle date click
  const handleDateClick = useCallback(info => alert(`Date clicked: ${info.dateStr}`), []);
  // Handle event click
  const handleEventClick = useCallback(info => alert(`Event clicked: ${info.event.title}`), []);
  // Handle drop (if you're using an external drag-and-drop library)
  const handleDrop = useCallback(() => alert("Drop detected!"), []);

  const getScreenHeight = (click) => {
    let screenHeight = document.getElementById('card-section').offsetHeight/2;
    document
      .querySelector('.react-bootstrap-table')
      .setAttribute('style', 'height: calc(' + screenHeight + 'px - 150px); overflow: auto;');
  };

  const getDaysArray = (startDate, endDate) => {
    let dates = [],
      currentDate = startDate,
      addDays = function (days) {
        var date = new Date(this.valueOf())
        date.setDate(date.getDate() + days)
        return date
      }
    while (currentDate <= endDate) {
      dates.push(currentDate)
      currentDate = addDays.call(currentDate, 1)
    }
    if (
      new Date(dates[dates.length - 1]).setHours(0, 0, 0, 0) !=
      new Date(end).setHours(0, 0, 0, 0)
    ) {
      dates.push(new Date(end))
    } else if (
      new Date(dates[dates.length - 1]).setHours(0, 0, 0, 0) ==
        new Date(end).setHours(0, 0, 0, 0) &&
      new Date(dates[dates.length - 1]).toLocaleTimeString("en-GB") !=
        new Date(end).toLocaleTimeString("en-GB")
    ) {
      dates[dates.length - 1] = new Date(end)
    }
    let publicHolidays = []
    //create holidays array from object
    holidays.map(holiday => {
      publicHolidays.push(new Date(holiday.start))
    })
    holidays.map(holiday => {
      publicHolidays.push(new Date(holiday.end))
    })
    // filter only working days excluding weekends and holidays
    var workingDays = dates.filter(function (e, index) {
      return (
        e.getDay() != 0 &&
        e.getDay() != 6 &&
        !publicHolidays.some(d => +d === +e)
      )
    })
    let workingHoursArr = []
    workingDays.map((day, key) => {
      let startDay = new Date(day).setHours(8, 0)
      let endDay = new Date(day).setHours(17, 0)
      if (workingDays.length == 1) {
        workingHoursArr.push(
          (day.getTime() - new Date(start)) / (1000 * 60 * 60) >= 9
            ? 8
            : (day.getTime() - new Date(start)) / (1000 * 60 * 60)
        )
      } else if (key === workingDays.length - 1) {
        workingHoursArr.push(
          (day.getTime() - startDay) / (1000 * 60 * 60) >= 9
            ? 8
            : (day.getTime() - startDay) / (1000 * 60 * 60)
        )
      } else if (key === 0) {
        workingHoursArr.push(
          (endDay - day.getTime()) / (1000 * 60 * 60) >= 9
            ? 8
            : (endDay - day.getTime()) / (1000 * 60 * 60)
        )
      } else {
        workingHoursArr.push((endDay - startDay) / (1000 * 60 * 60) - 1)
      }
    })
    const workingHours = workingHoursArr.reduce((a, b) => a + b, 0);
    return workingHours
  }
  /**
   * Handles uploaded file and returns an array of files
   */
  const handleAcceptedFiles = (files) => {
    const updatedFiles = files.map((file, index) => {
      // Get the current date in DD.MM.YY format
      const currentDate = new Date();
      const formattedDate = currentDate
        .toLocaleDateString("en-GB")
        .split("/")
        .join(".");
      // Construct the new file name
      const newName = `${profileData.fname}_${profileData.sname.split('#')[0].trim()}_${formattedDate}.pdf`;
      // Create a new File object with the updated name
      const renamedFile = new File([file], newName, { type: file.type });
      // Assign additional properties like preview and formattedSize
      return Object.assign(renamedFile, {
        preview: URL.createObjectURL(file),
        acceptedFiles: "image/*",
        formattedSize: formatBytes(file.size),
      });
    });
    setFile(updatedFiles);
  };
  /**
   * Formats the size
   */
  const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes"
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
  }

  const handleFileSubmit = async () => {
    const formData = new FormData();
    formData.append('file', selectedFile[0]);
    try {
      // Send files to the backend
      // const response = await fetch('http://1.215.140.110:999/leaves/uploadFile', {
      const response = await fetch('http://192.168.250.135:8080/leaves/uploadFile', {
        method: 'POST',
        body: formData,
      });
      if (!response.ok) throw new Error('File upload failed');
      const filePath = await response.json();
      return filePath
    } catch (error) {
      console.error('Error uploading file:', error);
    }
  }

  const handleValidLeaveSubmit = async (e, values) => {
    e.preventDefault();
    try {
      const filePath = selectedFile.length !==0 ? await handleFileSubmit() : '';
      const vacHours = getDaysArray(new Date(start), new Date(end));
      const leaveNames = {
        ann_lv: 'Annual Leave',
        unp_lv: 'Unpaid Leave',
        med_lv: 'Medical Leave',
        comp_lv: 'Compassionate Leave'
      };
      if((values["leaveType"] === "med_lv" && vacHours <= (medicalLeaveTaken*8)) || 
          (values["leaveType"] === "ann_lv" && vacHours <= (leftLeave*8)) ||
          (values["leaveType"] !== "ann_lv" && values["leaveType"] !== "med_lv") ||
          (values["leaveType"] === "med_lv" && selectedFile.length !==0)
        ) {  
          alert('inside');
        // if (isEdit) {
    
        // } else {
        //   const newLeave = {
        //     appliedBy: profileData._id,
        //     title: `${leaveNames[values["leaveType"]]}, ${profileData.fname} ${profileData.sname.slice(0, 1)}.`,
        //     leaveType: values["leaveType"],
        //     supervisor: values["supervisor"],
        //     start: start,
        //     end: end,
        //     hoursCount: vacHours,
        //     status: "Pending",
        //     className: "bg-warning text-white",
        //     reason: values["reason"],
        //     rejectReason: "",
        //     type: "newVac",
        //     msgName: `${profileData.fname} ${profileData.sname.slice( 0,  1 )}.`,
        //     date_start: new Date(start).toLocaleDateString("en-GB"),
        //     date_end: new Date(end).toLocaleDateString("en-GB"),
        //     selectedFile: filePath
        //   }
        //   const result = await addLeave(newLeave).unwrap();

        //   // Update local storage and state
        //   const updatedProfile = JSON.parse(localStorage.getItem("authUser"));
        //   updatedProfile.result.leave = result.leave;
        //   localStorage.setItem("authUser", JSON.stringify(updatedProfile));
    
        //   setProfileData(updatedProfile.result); // Update the state wit
        //   // Reset the state to default values
        //   setStart(new Date().setHours(8, 0));
        //   setEnd(new Date().setHours(17, 0));
        //   setFile([]);
        //   if (formRef.current) {
        //     formRef.current.reset();
        //   }
        // }
      } else {
        setLeaveType(values["leaveType"]);
        setShowErrorAlert(true)
      }
    } catch (error) {
      console.error('Error in leave submission:', error);
    }
  }
  /**
   * Delete rounding
   * @param {*} number 
   * @returns 
   */
  const removeRounding = (number) => number.toString().match(/^-?\d+/)[0];
  /**
   * Function to get public holidays and lock it inside the flatpickr calendar
   * @returns Array of dates containing public holidays
   */
  const getLockedDays = () => {
    let lockedDays = []
    holidays.map(value => {
      if (!lockedDays.includes(value.start)) {
        lockedDays.push(value.start)
      }
      if (!lockedDays.includes(value.end)) {
        lockedDays.push(value.end)
      }
    })
    leaves.filter(leave => leave.appliedBy === profileData._id).map(value => {
      if (!lockedDays.includes(value.start)) {
        lockedDays.push(value.start)
      }
      if (!lockedDays.includes(value.end)) {
        lockedDays.push(value.end)
      }
    })
    // Add holidays to lockedDays
    // holidays.forEach(value => {
    //   if (!lockedDays.includes(value.start)) {
    //     lockedDays.push(value.start);
    //   }
    //   if (!lockedDays.includes(value.end)) {
    //     lockedDays.push(
    //       new Date(new Date(value.end).setDate(new Date(value.end).getDate() - 1))
    //         .toLocaleDateString("en-GB")
    //         .split("/")
    //         .reverse()
    //         .join("-")
    //     );
    //   }
    // });

    // leaves.filter(leave => leave.appliedBy === profileData._id).forEach({
      
    // })

    // Add weekends to lockedDays
    const addWeekends = () => {
      let date = new Date(); // Start from the current date
      const nextYearEnd = new Date(date.getFullYear() + 1, 11, 31); // End of the next year
    
      while (date <= nextYearEnd) {
        const day = date.getDay();
        if (day === 0 || day === 6) {
          // Sunday (0) or Saturday (6)
          lockedDays.push(
            date.toLocaleDateString("en-GB").split("/").reverse().join("-")
          );
        }
        date.setDate(date.getDate() + 1); // Move to the next day
      }
    };

    addWeekends();
    return lockedDays
  }
  /**
   * Function to handle date input start
   * @param {Date} event
   */
  const [start, setStart] = useState(new Date().setHours(8, 0)); // Initialize state
  const getStartRange = (start) => setStart(new Date(start));
  /**
   * Function to handle date input end
   * @param {Date} event
   */
  const [end, setEnd] = useState(new Date().setHours(17, 0)); // Initialize state
  const getEndRange = (end) => setEnd(new Date(end));
  /**
   * Add leaves and holidays inside calendar
   * @returns array of dates
   */
  const getLeavesHolidaysData = () => {
    const cmb = [];
    combined.map((value) => {
      const newEnd = new Date(value.end).setHours(24, 0);
      cmb.push({ ...value, end: newEnd, allDay: true })
    })
    return cmb;
  }
  /**
   * Display company policy alert
   * @returns alert
   */
  const renderPolicyAlert = () => {
    return (
      <SweetAlert
        style={{ width: "80%" }}
        title={
          <>
            <p className="text-danger">Vacation Policies</p>
            <ul className="font-size-16" style={{ textAlign: "left" }}>
              <li>- 15 paid days are granted for the first year, every next year 1 more day is added.</li>
              <li>- Leave can be used only once per month.</li>
              <li>- Need to apply to use these days at least 2 weeks in advance.</li>
              <li>- During low-season months - (June/July/August - January/February), it is allowed to take up to 10 days off at one time.</li>
              <li>- During other months - max amount to be granted is up to 5 days per month.</li>
              <li>- Not allowed to take days off for a "sandwich day" - e.g. Wed-Thurs are public holidays, then you cannot apply for leave on Friday; everyone should work on that day. </li>
              <li>- Vacation should be used in such a way that there is no disruption to work.</li>
            </ul>
            <p className="text-danger">MC Leave Policies</p>
            <ul className="font-size-16" style={{ textAlign: "left" }}>
              <li>- 14 days of paid medical leave are granted per year.</li>
              <li>- A medical form with proof is required for each day taken.</li>
              <li>- If medical leave exceeds 14 days per year, it will be deducted from the annual leave or granted as unpaid leave (deducted from salary).</li>
            </ul>
          </>
        }
        onConfirm={() => setShowPolicyAlert(false)}
      />
    );
  };

  const renderErorrAlert = (type) => {
    return (
      <SweetAlert 
        title={
          (type === 'med_lv' && selectedFile.length ===0) ? 
            <>
              <p className="text-danger">Please attach medical certificate.</p>
            </> :
            <>
              <p className="text-danger">You only have {type === 'med_lv' ? medLeavesInfo : vacLeavesInfo} left.  </p>
              <p className="text-danger">Please use different leave type.</p>
            </>
        }
        danger
        onConfirm={() => setShowErrorAlert(false)}
      />
    );
  }

  // Extract distinct years
  const years = [...new Set(leaves.map(leave => new Date(leave.start).getFullYear()))];
  // const invalidLeaves = leaves.filter(leave => isNaN(new Date(leave.start).getFullYear()));

  const [selectedTimeFrame, setTimeFrame] = useState([]);
  const [filterValues, setFilterValues] = useState({
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1
  });
  const filterLvData = (event) => {
    const { name, value } = event.target;
    // Update the state with the selected year or month
    setFilterValues((prevState) => {
      const updatedValues = { ...prevState, [name]: value };
      // Filter leaves based on the updated filter values
      const filteredLeaves = leaves.filter(leave =>
        leave.appliedBy._id === profileData._id 
        && new Date(leave.start).getFullYear() === parseInt(updatedValues.year) 
        && new Date(leave.start).getMonth()+1 === parseInt(updatedValues.month)
      );
      // Update the selectedTimeFrame by appending new filtered leaves
      setTimeFrame(filteredLeaves);
      return updatedValues; // Ensure the new filterValues state is returned
    });
  }
  const resetLvData = () => {

  }
  const cancelEdit = () => {
    // Reset the state to default values
    setStart(new Date().setHours(8, 0));
    setEnd(new Date().setHours(17, 0));
    if (formRef.current) {
      formRef.current.reset();
    }
    setIsEdit(false);
  }

  const [newLeaves, pushLeavesData] = useState([]);
  const handleFileChange = (e)  => {
    const fname = e.target.files[0].name.split(' ')[0];
    const uname = fname.split('_')[0];
    const leaveType = fname.split('_')[1];
    const date = e.target.files[0].name.split(' ')[1].replace(/\.(pdf|xls|xlsx|doc|jpg)$/, "");
    const month = e.target.files[0].name.split(' ')[2].replace(/\.(pdf|xls|xlsx|doc|jpg)$/, "");
    const half = e.target.files[0].name.split(' ')[3] ? e.target.files[0].name.split(' ')[3].replace(/\.(pdf|xls|xlsx|doc|jpg)$/, "") : '';
    
    const appliedBy = users.find(user => user.fname === uname);
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
    const monthNumber = String(months.indexOf(month) + 1).padStart(2, '0');
    const start = `2023-${monthNumber}-${date}T00:00:00.000+0000`;
    const end = `2023-${monthNumber}-${date}T09:00:00.000+0000`;

    const newLv = {
      "appliedBy" : appliedBy._id,
      "title" : leaveType === 'AL' ? `Annual Leave, ${appliedBy.fname} ${appliedBy.sname.slice(0, 1)}.` : `Medical Leave, ${appliedBy.fname} ${appliedBy.sname.slice(0, 1)}.`,
      "leaveType" : leaveType === 'AL' ? "ann_lv" : "med_lv",
      "start" : start,
      "end" : end,
      "reason" : leaveType === 'AL' ? "vc" : "mc",
      "rejectReason" : "",
      "status" : "Approved",
      "hoursCount" : half !== '' ? 4 : 8,
      "className" : "bg-warning text-white",
      "selectedFile" : ""
    }
    pushLeavesData((prevLeaves) => [...prevLeaves, newLv]);
  }

  const leavesColumns = [
    {
      text: "ID",
      dataField: "_id",
      sort: true,
      editable: false,
      formatter: (cell, row, rowIndex) => rowIndex + 1,
    },
    {
      text: "Title",
      dataField: "title",
      sort: true,
      csvExport: false,
      hidden: false,
      editable: false,
      formatter: (cellContent, leave) => (
        <h5 className="font-size-16 mb-1 ">{leave.title}</h5>
      ),
    },
    {
      text: "Dates",
      dataField: "start",
      sort: true,
      csvExport: true,
      hidden: false,
      editable: false,
      formatter: (cellContent, leave) => (
        <h5 className="font-size-16 mb-1 text-center">
          {new Date(leave.start).toLocaleDateString("en-GB")} {leave.hoursCount < 8 && ","+new Date(leave.start).toLocaleTimeString("en-GB")}
          {
            new Date(leave.start).toLocaleDateString("en-GB") !== new Date(leave.end).toLocaleDateString("en-GB") &&
            <>
              <br />
              -//-
              <br />
              {new Date(leave.end).toLocaleDateString("en-GB")}{leave.hoursCount < 8 && ","+new Date(leave.end).toLocaleTimeString("en-GB")}
            </>
          }
        </h5>
      ),
    },
    {
      text: "Reason",
      dataField: "reason",
      sort: true,
      csvExport: false,
      hidden: false,
      editable: false,
      formatter: (cellContent, leave) => (
        <h5 className="font-size-16 mb-1">
          {leave.reason}
          {leave.rejectReason != "" && (
            <>
              <br />
              ~~~~
              <br />
              <span className="text-danger">{leave.rejectReason}</span>
            </>
          )}
        </h5>
      ),
    },
    {
      text: "Status",
      dataField: "status",
      sort: true,
      csvExport: false,
      hidden: false,
      editable: false,
      formatter: (cellContent, leave) => (
        <div className="text-center">
          {leave.status === "Approved" && (
            <Badge className={"font-size-12 badge-soft-success"} pill>
              {leave.status}
            </Badge>
          )}
          {leave.status === "Pending" && (
            <Badge className={"font-size-12 badge-soft-warning"} pill>
              {leave.status}
            </Badge>
          )}
          {leave.status === "Rejected" && (
            <Badge className={"font-size-12 badge-soft-danger"} pill>
              {leave.status}
            </Badge>
          )}
        </div>
      ),
    },
    {
      dataField: "menu",
      //   isDummyField: true,
      text: "File",
      editable: false,
      formatter: (cellContent, leave) => (
        <div className="d-flex gap-3">
          {/* {!leaves.status && ( */}
          <>
            {leave.selectedFile != "" && (
              <a className="text-primary" href={leave.selectedFile} target="_blank">
                <i
                  className="mdi mdi-file-pdf font-size-18"
                  // onClick={() => this.openPDFFile(leave)}
                ></i>
              </a>
            )}
            {/* <Link className="text-success" to="#">
              <i
                className="mdi mdi-pencil font-size-18"
                id="edittooltip"
                onClick={e => handleEditLeaveClick(e, leave)}
              ></i>
            </Link>
            <Link className="text-danger" to="#">
              <i
                className="mdi mdi-delete font-size-18"
                id="deletetooltip"
                onClick={() => this.handleDeleteLeave(leave)}
              ></i>
            </Link> */}
          </>
          {/* )} */}
        </div>
      ),
    },
  ];
  const pageOptions = {
    sizePerPage: leaves.length,
    sizePerPageList: [500, 1000, 1500],
    totalSize: leaves.length,
    custom: true,
  }
  const defaultSorted = [
    {
      dataField: 'date',
      order: 'asc'
    }
  ];
  return (
    <React.Fragment>
      {isLoading && <PageLoader />}
      <div className='page-content'>
        <MetaTags>
          <title>Apply For Leave</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title="Korupharma" breadcrumbItem="Battlefield" />
          <Row id="card-section">
            <Col lg="6">
              <Card>
                <CardHeader>
                  <Row className="d-flex align-items-center">
                    <Col lg="12">
                      <h2>Application Form</h2>
                    </Col>
                    {/* <Col lg="3" className="d-flex justify-content-end">
                      <h4> <b> Vacation: {vacLeavesInfo} </b> </h4>
                    </Col>
                    <Col lg="3" className="d-flex justify-content-end">
                      <h4> <b> Additional Days: {addLeavesInfo} </b> </h4>
                    </Col>
                    <Col lg="3" className="d-flex justify-content-end font-weight-bold" >
                      <h4><b> Medical: {medLeavesInfo} </b></h4>
                    </Col> */}
                  </Row>
                </CardHeader>
                <CardBody className="cardBodySticky">
                  <PaginationProvider
                    pagination={paginationFactory(pageOptions)}
                    keyField="_id"
                    columns={leavesColumns}
                    data={selectedTimeFrame.length !== 0 ? selectedTimeFrame : leaves.filter(leave => leave.appliedBy._id === profileData._id && new Date(leave.start).getFullYear() === new Date().getFullYear() && new Date(leave.start).getMonth() === new Date().getMonth())}
                  >
                    {({ paginationProps, paginationTableProps }) => (
                      <ToolkitProvider
                        keyField="_id"
                        columns={leavesColumns}
                        data={selectedTimeFrame.length !== 0 ? selectedTimeFrame : leaves.filter(leave => leave.appliedBy._id === profileData._id && new Date(leave.start).getFullYear() === new Date().getFullYear() && new Date(leave.start).getMonth() === new Date().getMonth())}
                        search
                      >
                        {toolkitprops => (
                          <React.Fragment>
                            <Row className="mb-5">
                              <Col md={4} className="font-size-12 terms text-center pt-2">
                              <Row>
                                <Col md={12} className="mb-3">
                                  <h4><a href="#" onClick={() => setShowPolicyAlert(true)}> Company Policies </a></h4>
                                  {showPolicyAlert && renderPolicyAlert()}
                                </Col>
                              </Row>
                              <hr/>
                              <Row>
                                <Col md={12} className="mb-3"><h4><b>Vacation: {vacLeavesInfo} Days</b></h4></Col>
                                <Col md={12} className="mb-3"><h4><b>Additional: {addLeavesInfo} Days</b></h4></Col>
                                <Col md={12} className="mb-3"><h4><b>Medical: {medLeavesInfo} </b></h4></Col>
                              </Row>
                              <hr/>
                              <Row>
                                <Col md={12} className="mb-3">
                                  <h4><b>Total Taken: <span className='text-danger'>{totalLeavesTaken} Days</span></b></h4>
                                </Col>
                                <Col md={12} className="mb-3">
                                  <h4>
                                    <b>Total Vacation Left: <span className={leftLeave >= 0 ? 'text-success' : 'text-danger'}>{parseFloat(leftLeave).toFixed(2)} Days</span></b>
                                  </h4>
                                </Col>
                                <Col md={12} className="mb-3">
                                  <h4>
                                    <b>Total Medical Left: <span className={medicalLeaveTaken >= 0 ? 'text-success' : 'text-danger'}>{medicalLeaveTaken} Days</span></b>
                                  </h4>
                                </Col>
                              </Row>

                              </Col>
                              <Col md={8}>
                              <AvForm onValidSubmit={handleValidLeaveSubmit} ref={formRef}>
                                <Row>
                                  <Col md={6}>
                                    <FormGroup className="mb-3">
                                      <AvField
                                        type="select"
                                        name="leaveType"
                                        className="form-select"
                                        label="Leave Type"
                                        errorMessage="Please select leave type"
                                        validate={{
                                          required: {
                                            value: true,
                                          },
                                        }}
                                        // value={
                                        //   this.state.leaves.leaveType
                                        //     ? this.state.leaves
                                        //         .leaveType
                                        //     : ""
                                        // }
                                      >
                                        <option value=''>Select Leave Type</option>
                                        <option value='ann_lv'>Annual Leave</option>
                                        <option value='unp_lv'>Unpaid Leave</option>
                                        <option value='med_lv'>Medical Leave</option>
                                        <option value='comp_lv'>Compassionate Leave</option>
                                        <option value='ann_lv'>Emergency Leave</option>
                                      </AvField>
                                    </FormGroup>
                                  </Col>
                                  <Col md={6}>
                                    <FormGroup className="mb-3">
                                      <AvField
                                        type="select"
                                        name="supervisor"
                                        className="form-select"
                                        label="Supervisor"
                                        errorMessage="Please select Supervisor"
                                        validate={{
                                          required: {
                                            value: true,
                                          },
                                        }}
                                        // value={
                                        //   this.state.leaves.supervisor
                                        //     ? this.state.leaves
                                        //         .supervisor
                                        //     : ""
                                        // }
                                      >
                                        <option value=''> Select Supervisor</option>
                                        {supervisors.map(user => {
                                          return (
                                            <option
                                              key={user._id}
                                              value={user.supervisorEmail}
                                            >
                                              {user.fname} {user.sname}
                                            </option>
                                          )
                                        })}
                                      </AvField>
                                    </FormGroup>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col md={6}>
                                    <FormGroup className="mb-4">
                                      <Label>Date From</Label>
                                      <InputGroup>
                                        <Flatpickr
                                          className="form-control d-block"
                                          name="startDate"
                                          placeholder="dd M,yyyy"
                                          // errorMessage="Please select correct range"
                                          validate={{
                                            required: {
                                              value: true,
                                            },
                                          }}
                                          value={start}
                                          options={{
                                            dateFormat: "Y-m-d H:i",
                                            enableTime: true,
                                            minTime: "08:00",
                                            maxTime: "17:00",
                                            disable: getLockedDays(), // Disable specific dates
                                            time_24hr: true,
                                          }}
                                          onClose={getStartRange}
                                        />
                                      </InputGroup>
                                    </FormGroup>
                                  </Col>
                                  <Col md={6}>
                                    <FormGroup className="mb-4">
                                      <Label>Date To</Label>
                                      <InputGroup>
                                        <Flatpickr
                                          className="form-control d-block"
                                          name="endDate"
                                          placeholder="dd M,yyyy"
                                          // errorMessage="Please select correct range"
                                          validate={{
                                            required: {
                                              value: true,
                                            },
                                          }}
                                          value={end}
                                          options={{
                                            dateFormat: "Y-m-d H:i",
                                            enableTime: true,
                                            minTime: "08:00",
                                            maxTime: "17:00",
                                            disable: getLockedDays(), // Disable specific dates
                                            time_24hr: true,
                                            // defaultDate:  new Date().setHours(18, 0),
                                          }}
                                          onClose={getEndRange}
                                        />
                                      </InputGroup>
                                    </FormGroup>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col md={12}>
                                    <FormGroup className="mb-3">
                                      <AvField
                                        name="reason"
                                        label="Reason"
                                        type="text"
                                        // rows="4"
                                        errorMessage="Please input correct reason"
                                        validate={{
                                          required: {
                                            value: true,
                                          },
                                        }}
                                         value=''
                                        // value={
                                        //   this.state.leaves.reason || ""
                                        // }
                                      />
                                    </FormGroup>
                                  </Col>
                                  <Col md={12} className="d-flex align-items-center mt-2 mb-4 leave" >
                                    <Dropzone
                                      accept=".jpeg,.jpg,.png,.pdf"
                                      onDrop={acceptedFiles => handleAcceptedFiles(acceptedFiles)}
                                    >
                                      {({ getRootProps, getInputProps }) => (
                                        <div className="dropzone">
                                          <div
                                            className="dz-message needsclick"
                                            {...getRootProps()}
                                          >
                                            <input {...getInputProps()} />
                                            <div className="">
                                              <i className="display-4 text-muted bx bxs-cloud-upload" />
                                            </div>
                                            <h4>Drop files here or click to upload.</h4>
                                          </div>
                                        </div>
                                      )}
                                    </Dropzone>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col>
                                    <div className="text-end">
                                      {isLoading && ( <BtnLoader /> )}
                                      {isEdit && (
                                        <button className="btn btn-primary save-user me-3" onClick={() => cancelEdit()}> Cancel</button>
                                      )}
                                      <button className="btn btn-success save-user"
                                        // disabled={
                                        //   !this.state.correctDate ||
                                        //   (this.props.loading && true)
                                        // }
                                      >
                                        {!!isEdit
                                          ? "Edit Leave Application"
                                          : "Submit Application"}
                                      </button>
                                    </div>
                                  </Col>
                                </Row>
                              </AvForm>
                              {showErrorAlert && renderErorrAlert(leaveType)}
                              </Col>
                              {/* <Col md={2} className="font-size-12 terms">
                              </Col> */}
                            </Row>
                            <Row className="leave-table">
                              <AvForm className='d-flex justify-content-end mb-3'>
                                <FormGroup className='me-1'>
                                  <AvField type='select' name='year' id='year' value={filterValues.year} onChange={filterLvData} className='form-select'>
                                    {years.map((year) => (
                                      <option value={year} className='fw-bold fs-5'>
                                        {year}
                                      </option>
                                    ))}
                                  </AvField>
                                </FormGroup>
                                <FormGroup className='me-1'>
                                  <AvField type='select' name='month' className='form-select' value={filterValues.month} onChange={filterLvData}>
                                    <option value='01' className='fw-bold fs-5'> January </option>
                                    <option value='02' className='fw-bold fs-5'> February </option>
                                    <option value='03' className='fw-bold fs-5'> March </option>
                                    <option value='04' className='fw-bold fs-5'> April </option>
                                    <option value='05' className='fw-bold fs-5'> May </option>
                                    <option value='06' className='fw-bold fs-5'> June </option>
                                    <option value='07' className='fw-bold fs-5'> July </option>
                                    <option value='08' className='fw-bold fs-5'> August </option>
                                    <option value='09' className='fw-bold fs-5'> September </option>
                                    <option value='10' className='fw-bold fs-5'> October </option>
                                    <option value='11' className='fw-bold fs-5'> November </option>
                                    <option value='12' className='fw-bold fs-5'> December </option>
                                  </AvField>
                                </FormGroup>
                              </AvForm>
                            </Row>
                            <Row id="table-section" className="">
                              <BootstrapTable
                                {...toolkitprops.baseProps}
                                {...paginationTableProps}
                                defaultSorted={defaultSorted}
                                classes={
                                  "table align-middle table-nowrap "
                                }
                                headerClasses="header-class is-sticky-hdr"
                                id="tableScroll"
                                bordered={true}
                                responsive
                              />
                              {/* <Col className="inner-custom-pagination d-flex mt-1">
                                <div className="d-inline">
                                  <SizePerPageDropdownStandalone
                                    {...paginationProps}
                                  />
                                </div>
                                <div className="text-md-right ms-auto pagination pagination-rounded justify-content-end mb-2">
                                  <PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </div>
                              </Col> */}
                            </Row>
                          </React.Fragment>
                        )}
                      </ToolkitProvider>
                    )}
                  </PaginationProvider>
                </CardBody>
              </Card>
            </Col>
            <Col lg="6">
              <Card>
                <CardBody className="cardBodySticky">
                  <FullCalendar
                    ref={calendarComponentRef}
                    plugins={[
                      BootstrapTheme,
                      dayGridPlugin,
                      interactionPlugin,
                    ]}
                    // slotDuration={"00:15:00"}
                    weekends={false}
                    handleWindowResize={true}
                    themeSystem="bootstrap"
                    headerToolbar={{
                      left: "prev,next today",
                      center: "title",
                      right: "dayGridMonth,dayGridWeek,dayGridDay",
                    }}
                    events={getLeavesHolidaysData()}
                    // editable={true}
                    // droppable={true}
                    selectable={true}
                    dateClick={handleDateClick}
                    eventClick={handleEventClick}
                    drop={handleDrop}
                    height="85vh"
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );  
}